import React from 'react'
import { useTranslation } from 'react-i18next'
import TextInput from '../../../../../../../common/inputs/textInput/TextInput'
import { useFormState } from '../../../../../wizard/useFormState'
import { ContentStateProperty } from '../../../../../../../../@types/types'

export interface RentalIncomeProps {
  screenId: string
  rentalIncome?: string
  rentalIncomeValidation: string[]
  onChange: (property: ContentStateProperty, value: string | undefined) => void
}

const RentalIncomeField: React.FC<RentalIncomeProps> = ({ rentalIncome, rentalIncomeValidation, onChange }) => {
  const { formState } = useFormState()
  const { t } = useTranslation()

  const showErrors = () =>
    rentalIncomeValidation.length > 0 && (formState.submitCount > 0 || formState.touched.rentalIncome)

  return (
    <div className='inline-block margin-top-m one-whole'>
      <div className='inline-block vertical-center-container'>
        <span className='vertical-center lap-margin-left-m desk-margin-left-m margin-left-xxl path-symbol-before' />
      </div>
      <div className='inline-block desk-seven-twelfths lap-eight-twelfth palm-ten-twelfth'>
        <TextInput
          id='rental-income-field'
          propertyName='rentalIncome'
          placeholder={t('wizard.screen.otherFacilities.rentalIncomeField', 'Rental income')}
          value={rentalIncome}
          type='text'
          errors={[]}
          showRedBoarder={rentalIncomeValidation.length > 0}
          doOnFieldChange={(property, value) => onChange(property, value !== '' ? value : undefined)}
        />
      </div>
      {showErrors() && (
        <span
          role='alert'
          className='input-label-helper-text font-error'
          aria-label={t('wizard.screen.otherFacilities.rentalIncomeField', 'Rental income')}
        >
          {t(`validation.${rentalIncomeValidation[0]}`)}
        </span>
      )}
    </div>
  )
}

export default RentalIncomeField
